import { ArrowUpRight } from "lucide-react";
import { AnimatedNumber } from "./AnimatedNumber";
import { inr, productImage } from "../../lib/api";
import { useLang } from "../../lib/i18n";

export const StockCard = ({ product, onOrder }) => {
  const { t } = useLang();
  const subtitle = t(`sub.${product.slug}`) === `sub.${product.slug}` ? product.subtitle : t(`sub.${product.slug}`);
  const low = product.stock_t < 10;
  const out = product.stock_t <= 0;
  const onMove = (e) => {
    const r = e.currentTarget.getBoundingClientRect();
    e.currentTarget.style.setProperty("--mx", `${e.clientX - r.left}px`);
    e.currentTarget.style.setProperty("--my", `${e.clientY - r.top}px`);
  };
  return (
    <article onMouseMove={onMove} data-testid={`stock-card-${product.slug}`} className="group relative h-full overflow-hidden rounded-[28px] border hairline bg-[var(--forest-2)] p-4 flex flex-col">
      <div className="absolute inset-0 spotlight opacity-0 group-hover:opacity-100 transition-opacity duration-500 pointer-events-none" />
      <div className="relative grid grid-cols-[112px_1fr] sm:grid-cols-[132px_1fr] gap-4">
        <div className="relative aspect-square overflow-hidden rounded-[20px] ring-1 ring-[#0F8A78]/40">
          <img src={productImage(product.slug)} alt={subtitle} loading="lazy" className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-110" />
        </div>
        <div className="flex flex-col">
          <div className="flex items-start justify-between gap-2">
            <h3 className="font-display text-xl sm:text-2xl font-semibold tracking-tight">{product.name}</h3>
            <span className="font-mono text-[11px] rounded-full border hairline px-2 py-1 text-[var(--sage)]">{product.size}</span>
          </div>
          <p className="text-sm text-[var(--sage)]">{subtitle}</p>
          <div className="mt-auto flex items-baseline gap-1.5">
            <AnimatedNumber value={product.stock_t} decimals={0} testId={`stock-qty-${product.slug}`} className="font-display text-4xl font-bold tracking-tight" />
            <span className="font-mono text-xs text-[var(--sage)]">{t("stock.available")}</span>
          </div>
        </div>
      </div>
      <div className="relative mt-4 flex flex-wrap gap-1.5 font-mono text-[11px] text-[var(--sage)]">
        <span className="rounded-full bg-white/5 px-2.5 py-1">{t("stock.gcv")} {product.gcv}</span>
        <span className="rounded-full bg-white/5 px-2.5 py-1">{t("stock.moist")} {product.moisture}</span>
        <span className="rounded-full bg-white/5 px-2.5 py-1">{t("stock.ash")} {product.ash}</span>
      </div>
      <div className="relative mt-4 pt-4 border-t hairline flex items-center justify-between gap-3">
        <div>
          <p data-testid={`stock-price-${product.slug}`} className="font-semibold">{inr(product.price_per_t)}<span className="text-[var(--sage)] font-normal text-sm">{t("stock.perTonne")}</span></p>
          <p className={`font-mono text-[11px] ${out ? "text-red-300" : low ? "text-amber-300" : "text-emerald-300"}`}>{out ? t("stock.out") : low ? t("stock.low") : t("stock.ready")}</p>
        </div>
        <button
          data-testid={`stock-order-btn-${product.slug}`}
          disabled={out}
          onClick={() => onOrder(product.slug)}
          className="inline-flex items-center gap-1.5 rounded-full bg-[var(--cream)] text-[var(--forest)] px-4 py-2.5 text-sm font-semibold transition-all hover:bg-[var(--husk)] disabled:opacity-40 disabled:pointer-events-none"
        >
          {t("stock.order")} <ArrowUpRight className="h-4 w-4" />
        </button>
      </div>
    </article>
  );
};
